export default __webpack_public_path__ + "static/media/pantry1-afterE-1440w.a6bdae9a.png";